<script setup lang="ts">
import { OrganizationSelector } from '@rfc/rfc-components-library'
import type { Columns } from '@rfc/rfc-components-library/types'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { EEventActions } from '../../../store/eventStore/EventStoreTypes'
import EventsTableView from '../../EventsView/EventsTableView.vue'

const { t } = useI18n()

const adminColumns = computed<Columns[]>(() => [
    { value: 'organization_name', title: t('event.table.organizationName') }
])
</script>

<template>
    <EventsTableView
        :stateAction="EEventActions.GET_ADMIN_EVENTS"
        :propsColumns="adminColumns"
        disableEdit>
        <template #eventFilters="props">
            <OrganizationSelector
                :organizationId="
                    props.filters?.organization_id
                        ? parseInt((props.filters?.organization_id ?? '').toString())
                        : undefined
                "
                @select="props.onChange({ organization_id: $event?.id })"
                class="w-full" />
        </template>
    </EventsTableView>
</template>
